module.exports = __webpack_public_path__ + "img/wechat.520c3ce9.png";